/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddSessionAssetsRequest,
    AddSessionAssetsRequestFromJSON,
    AddSessionAssetsRequestToJSON,
    OpenSessionResult,
    OpenSessionResultFromJSON,
    OpenSessionResultToJSON,
    Session,
    SessionFromJSON,
    SessionToJSON,
    SessionRequest,
    SessionRequestFromJSON,
    SessionRequestToJSON,
} from '../models';

export interface GetSessionRequest {
    sessionId: string;
}

export interface SessionAddAssetSessionIdAssetIdPostRequest {
    sessionId: string;
    assetId: number;
}

export interface SessionAddAssetsPostRequest {
    addSessionAssetsRequest?: AddSessionAssetsRequest;
}

export interface SessionGetPropertySessionIdGetRequest {
    sessionId: string;
    key: string;
}

export interface SessionOpenPostRequest {
    sessionRequest?: SessionRequest;
}

export interface SessionRemoveAssetsPostRequest {
    addSessionAssetsRequest?: AddSessionAssetsRequest;
}

export interface SessionSetPropertySessionIdGetRequest {
    sessionId: string;
    key: string;
    value: string;
}

/**
 * no description
 */
export class SessionApi extends runtime.BaseAPI {

    /**
     * get session for session id
     * get session for session id
     */
    async getSessionRaw(requestParameters: GetSessionRequest): Promise<runtime.ApiResponse<Session>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getSession.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/session/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionFromJSON(jsonValue));
    }

    /**
     * get session for session id
     * get session for session id
     */
    async getSession(requestParameters: GetSessionRequest): Promise<Session> {
        const response = await this.getSessionRaw(requestParameters);
        return await response.value();
    }

    /**
     * add an asset to session
     * add an asset to session
     */
    async sessionAddAssetSessionIdAssetIdPostRaw(requestParameters: SessionAddAssetSessionIdAssetIdPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling sessionAddAssetSessionIdAssetIdPost.');
        }

        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
            throw new runtime.RequiredError('assetId','Required parameter requestParameters.assetId was null or undefined when calling sessionAddAssetSessionIdAssetIdPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/session/addAsset/{sessionId}/{assetId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters.assetId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * add an asset to session
     * add an asset to session
     */
    async sessionAddAssetSessionIdAssetIdPost(requestParameters: SessionAddAssetSessionIdAssetIdPostRequest): Promise<void> {
        await this.sessionAddAssetSessionIdAssetIdPostRaw(requestParameters);
    }

    /**
     * add assets to session
     * add assets to session
     */
    async sessionAddAssetsPostRaw(requestParameters: SessionAddAssetsPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/session/addAssets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSessionAssetsRequestToJSON(requestParameters.addSessionAssetsRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * add assets to session
     * add assets to session
     */
    async sessionAddAssetsPost(requestParameters: SessionAddAssetsPostRequest): Promise<void> {
        await this.sessionAddAssetsPostRaw(requestParameters);
    }

    /**
     * get a property from a session
     * get a property from a session
     */
    async sessionGetPropertySessionIdGetRaw(requestParameters: SessionGetPropertySessionIdGetRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling sessionGetPropertySessionIdGet.');
        }

        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling sessionGetPropertySessionIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/session/getProperty/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * get a property from a session
     * get a property from a session
     */
    async sessionGetPropertySessionIdGet(requestParameters: SessionGetPropertySessionIdGetRequest): Promise<string> {
        const response = await this.sessionGetPropertySessionIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * create a new session
     * create a new session
     */
    async sessionOpenPostRaw(requestParameters: SessionOpenPostRequest): Promise<runtime.ApiResponse<OpenSessionResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/session/open`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionRequestToJSON(requestParameters.sessionRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OpenSessionResultFromJSON(jsonValue));
    }

    /**
     * create a new session
     * create a new session
     */
    async sessionOpenPost(requestParameters: SessionOpenPostRequest): Promise<OpenSessionResult> {
        const response = await this.sessionOpenPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * remove assets from session
     * remove assets from session
     */
    async sessionRemoveAssetsPostRaw(requestParameters: SessionRemoveAssetsPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/session/removeAssets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSessionAssetsRequestToJSON(requestParameters.addSessionAssetsRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * remove assets from session
     * remove assets from session
     */
    async sessionRemoveAssetsPost(requestParameters: SessionRemoveAssetsPostRequest): Promise<void> {
        await this.sessionRemoveAssetsPostRaw(requestParameters);
    }

    /**
     * add a property to session
     * add a property to session
     */
    async sessionSetPropertySessionIdGetRaw(requestParameters: SessionSetPropertySessionIdGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling sessionSetPropertySessionIdGet.');
        }

        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling sessionSetPropertySessionIdGet.');
        }

        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value','Required parameter requestParameters.value was null or undefined when calling sessionSetPropertySessionIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        if (requestParameters.value !== undefined) {
            queryParameters['value'] = requestParameters.value;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/session/setProperty/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * add a property to session
     * add a property to session
     */
    async sessionSetPropertySessionIdGet(requestParameters: SessionSetPropertySessionIdGetRequest): Promise<void> {
        await this.sessionSetPropertySessionIdGetRaw(requestParameters);
    }

}
